import React from 'react';
import {
  QrCode, MapPin, MessagesSquare, Phone, Sparkles, Zap,
  FileSpreadsheet, ClipboardCheck, Megaphone, Building2, BarChart3, Vote,
} from 'lucide-react';
import { useT } from './i18n';

const items = [
  { icon: QrCode, labelKey: 'marquee.qrAttendance' },
  { icon: MapPin, labelKey: 'marquee.locationVerify' },
  { icon: MessagesSquare, labelKey: 'marquee.groupChat' },
  { icon: Phone, labelKey: 'marquee.callsVideo' },
  { icon: Sparkles, labelKey: 'marquee.aiAssistant' },
  { icon: Zap, labelKey: 'marquee.autoShiftEnd' },
  { icon: FileSpreadsheet, labelKey: 'marquee.payrollExport' },
  { icon: ClipboardCheck, labelKey: 'marquee.changeRequests' },
  { icon: Vote, labelKey: 'marquee.polls' },
  { icon: Megaphone, labelKey: 'marquee.companyNews' },
  { icon: Building2, labelKey: 'marquee.multipleWorkplaces' },
  { icon: BarChart3, labelKey: 'marquee.statistics' },
];

// Nekonečný pás funkcií — obsah je zdvojený, CSS animácia posúva o -50 %.
const LandingMarquee = () => {
  const t = useT();
  return (
    <div className="landing-marquee" aria-hidden>
      <div className="landing-marquee__viewport">
        <div className="landing-marquee__track">
          {[0, 1].map((copy) => (
            <div key={copy} className="landing-marquee__group">
              {items.map(({ icon: Icon, labelKey }) => (
                <span key={`${copy}-${labelKey}`} className="landing-marquee__chip">
                  <Icon size={16} strokeWidth={2} />
                  {t(labelKey)}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingMarquee;
